import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'parsleyjs';
import $ from 'jquery';
import { loginUser } from '../../api/auth';
import {Link} from "react-router-dom";

const Login = (props) => {

    const dispatch = useDispatch();

    const school_id = props.match.params.id || null;

    useEffect(() => {
        $('#login').parsley();

        if(school_id !== null) {
            $('#school_id').val(school_id).prop("disabled", true);
        }

        return () => {
            $('#login').parsley("destroy");
        }
    }, []);

    //Selector
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [stateReady, setStateReady] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);
        dispatch(loginUser($('#school_id').val(), $('#student_id').val(), $('#password').val())).then(() => {
            setStateReady(false);
        });
    };

    if(isAuthenticated) {
        props.history.push('/academics');
    }

    return (
        <div id="wrapper" className="flex flex-col justify-between h-screen">
            <div className="bg-white py-4 shadow dark:bg-gray-800">
                <div className="max-w-6xl mx-auto">
                    <div className="flex items-center lg:justify-between justify-around">
                        <Link to="/" className="flex font-semibold items-center lg:text-2xl text-xl text-black">
                            <span className="logo-name">ZStudy</span>
                        </Link>
                    </div>
                </div>
            </div>


            <div>
                <div className="lg:p-12 max-w-xl lg:my-0 my-12 mx-auto p-6 space-y-">
                    <form className="parsley-style-1 lg:p-10 p-6 space-y-3 relative bg-white shadow-xl rounded-md" autoComplete="off" id="login" data-parsley-validate="true" onSubmit={handleSubmit.bind()}>
                        <h1 className="lg:text-2xl text-xl font-semibold mb-6"> Login</h1>
                        <div id="schoolWrapper" className="parsley-input">
                            <label className="mb-0" htmlFor="student"> School ID </label>
                            <input type="text" id="school_id" placeholder="Enter school ID" className="parsley-input h-12 mt-2 px-3 rounded-md w-full" data-parsley-class-handler="#schoolWrapper" required/>
                        </div>
                        <div id="studentWrapper" className="parsley-input">
                            <label className="mb-0" htmlFor="student"> Student Number </label>
                            <input type="text" id="student_id" placeholder="Enter your student number" className="parsley-input h-12 mt-2 px-3 rounded-md w-full" data-parsley-class-handler="#studentWrapper" required/>
                        </div>
                        <div id="passwordWrapper" className="parsley-input">
                            <label className="mb-0" htmlFor="password"> Password </label>
                            <input type="password" id="password" autoComplete = "new-password" placeholder="******" className="bg-gray-100 h-12 mt-2 px-3 rounded-md w-full" data-parsley-class-handler="#passwordWrapper" required/>
                        </div>

                        <div>
                            {stateReady ? <button className="bg-blue-600 font-semibold p-2.5 mt-5 rounded-md text-center text-white w-full" disabled>Please Wait</button> : <button className="bg-blue-600 font-semibold p-2.5 mt-5 rounded-md text-center text-white w-full">Login with your account</button>}
                        </div>
                    </form>
                </div>

            </div>

            <div className="lg:mb-5 py-3 uk-link-reset">
                <div className="items-center uk-text-center max-w-6xl mx-auto lg:space-y-0 space-y-3">
                    <p className="capitalize"> © copyright {new Date().getFullYear()} by HCS Engineering</p>
                </div>
            </div>
        </div>
    )
};

export default Login;
